// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "script-" + "7c798a5725f9ea16d84c" + "-ie.js";
};